<template>
  <div class="modalBox">
    <Card class="left">
      <p slot="title">选择</p>
      <Input
        style="margin-bottom: 15px;"
        v-model="keyword"
        placeholder="搜索"
        @on-change="handlerSearchange"
      />
      <div
        v-if="this.multiple"
        style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;"
      >
        <Checkbox :value="checkAll" @click.prevent.native="handleCheckAll">
          全选
        </Checkbox>
      </div>
      <Tree
        ref="tree"
        class="demo-tree-render"
        :data="list"
        :show-checkbox="multiple"
        @on-select-change="onSelectChange"
        @on-check-change="onCheckChange"
        :check-strictly="true"
      ></Tree>
    </Card>
    <Card class="center"></Card>
    <Card class="right">
      <p slot="title">已选</p>
      <Row
        :gutter="24"
        class="leftContent"
        v-for="item in selectList"
        :key="item.id"
      >
        <Col :span="20" class="text">
          <Tooltip v-showtip placement="top" transfer>
            <div slot="content" style="white-space: normal;">
              {{ item.title }}
            </div>
            <div class="ellipsis">
              <span class="ellipse-text">{{ item.title }}</span>
            </div>
          </Tooltip>
        </Col>
        <Col :span="4">
          <Icon class="cursor" type="md-close" @click="deleteItem(item)" />
        </Col>
      </Row>
    </Card>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
export default {
  props: {
    // title展示
    title: {
      type: String,
      default: ''
    },
    // 是否多选  true 多选  false 单选
    multiple: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    showPath: {
      type: Boolean,
      default: true
    },
    allData: {
      type: Array,
      default: () => []
    },
    baseId: {
      type: String,
      default: ''
    },
    customTreeList: {
      type: Array,
      default: () => []
    },
    searchList: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    selectList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkBoxData: [],
      // 查询用，部门用，写死不用改变，为了方便使用
      filter: {
        pageIndex: 1,
        pageSize: 200
      },
      activeId: '',
      keyword: '',
      timer: null,
      checkAll: false
    };
  },
  computed: {
    getListMethod() {
      let method = 'setGroupList';
      if (this.type == 'person' && !this.multiple) method = 'setGroupAndPerson';
      if (this.type == 'person' && this.multiple) method = 'setAllPerson';
      return method;
    }
  },
  methods: {
    handleItemClick(slectItem) {
      // 只有单选才会走这边的逻辑，多选走checkbox
      /*
        判断一下是选择部门还是选择人员
        如果是选择人员的话，但是选择的是部门的数据，就啥也不做
        如果是选择部门的话，走筛选的逻辑
      */
      if (this.type == 'person' && slectItem.isGroup) {
        return false;
      }
      // 判断是单选还是多选
      // 如果是单选的话，就替换掉
      // 如果是多选，就差看一下是否已经存在过了，如果存在过，就不再添加了，如果没有存在过，就加上
      this.checkBoxData = [slectItem.id];
    },
    deleteItem(selectItem) {
      // 如果是多选的时候把checkbox里面的数据也给清空,因为checkBox监听操作了，不需要更改selectlist内容了
      this.$emit('on-delete-item', selectItem);
    },
    init() {
      this.activeId = this.baseId;
      /*
        初始化数据分为多种情况，
          如果是多选人员的话，就不需要使用this.customTreeList的的数据
          如果是单选人员的话，使用部门和部门人员拼接起来的数据
          如果是部门不管单选多选，就只用部门的数据
      */
    },
    handlerSearchange: debounce(function() {
      const value = this.keyword;
      this.$emit('on-input-change', value);
    }, 500),

    handleCheckAll() {
      if (this.list.length < 1) return false;
      this.checkAll = !this.checkAll;
      this.$emit('on-select-all', { type: this.type, checkAll: this.checkAll });
    },
    onCheckChange(arr, item) {
      // checked 为 true 是选中，为 false 是取消选中
      const isDelete = !item.checked;
      this.$emit('on-check-change', {
        isDelete,
        changeItem: item,
        type: this.type
      });
    },
    onSelectChange(arr, item) {
      if (this.multiple) return (item.selected = false);
      // 如果不需要点击每一行的就直接 把 selected 制为 false 就不会选中了
      if (!item.needSelected) return (item.selected = false);
      // 因为在点击 iview tree 为选中的时候，再次点击 tree 则会取消选中，所以在取消选中的时候再次给 selected 制为 true 此时高亮就不会消失了
      if (!item.selected) return (item.selected = true);
      this.$emit('on-select-change', { selectItem: item, type: this.type });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped>
.modalBox {
  display: flex;
  height: 400px;
}
.modalBox .left,
.modalBox .center,
.modalBox .right {
  height: 100%;
}
.left,
.right {
  width: 45%;
  overflow-y: auto;
  overflow-x: hidden;
}
.center {
  width: 10%;
}
.leftContent {
  margin: 5px 0;
}
.cursor {
  cursor: pointer;
}
.ellipsis {
  width: 255px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
